








import Vue from "vue";
import Component from "vue-class-component";
import AppFooter from "@/components/Base/Footer/Footer.vue";
import LoadingScreen from "@/components/Util/Loading/LoadingScreen/LoadingScreen.vue";
import { bus } from "@/main";

import * as LogoClinicarx from "@/assets/images/Logo_nova.png";

@Component({
  name: "App",
  components: {
    "loading-screen": LoadingScreen,
    AppFooter,
  },
  metaInfo: {
    title: "Agendamento online de Serviços de saúde | Clinicarx",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Faça aqui o agendamento online de serviços de saúde na farmácia mais próxima. Exames laboratoriais, vacinas, procedimentos e muito mais!",
      },
    ],
  },
})
export default class App extends Vue {
  cr_global_loading_enable = false;
  display_footer = true;
  cx_footer_logo = LogoClinicarx;
  cx_is_iframe = false;

  mounted() {
    if (this.$route.path.includes('iframe')) {
      // Verifica se a rota é iframe para manter somente a rota renderizada
      this.cx_is_iframe = true;
    }

    this.cx_footer_logo = LogoClinicarx;

    bus.$on("showLoading", (state: boolean) => {
      this.cr_global_loading_enable = state;
    });

    bus.$on("showFooter", (state: boolean) => {
      this.display_footer = state;
    });


    if ("serviceWorker" in navigator) {
      // Use the window load event to keep the page load performant
      window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js");
      });
    }
  }
}
